import { Box, Grid, Tab, Tabs } from "@mui/material";
import Table from "./home/table";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { MdAccountBalanceWallet, MdPayment } from "react-icons/md";
import EpaymentTransactionsTable from "../../../payments/transactions/home/table";

const Transactions = () => {
  const user = useSelector((state) => state.user.user.form);
  const isPos = user?.role === "pos";
  const [subTab, setSubTab] = useState(0);

  return (
    <Grid container spacing={2}>
      {isPos && (
        <Grid item xs={12}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <Tabs
              value={subTab}
              onChange={(e, newValue) => setSubTab(newValue)}
              aria-label="dejlah transactions tabs"
              variant="fullWidth"
              sx={{ background: "white" }}
            >
              <Tab
                icon={<MdAccountBalanceWallet size={22} />}
                iconPosition="start"
                label="المعاملات المالية"
              />
              <Tab
                icon={<MdPayment size={22} />}
                iconPosition="start"
                label="الدفع الالكتروني"
              />
            </Tabs>
          </Box>
        </Grid>
      )}

      <Grid item xs={12}>
        {/* Kept mounted so its state/data survive tab switches; hidden when the
            e-payment sub-tab is active. */}
        <Box sx={{ display: !isPos || subTab === 0 ? "block" : "none" }}>
          <Table />
        </Box>
        {isPos && subTab === 1 && (
          <EpaymentTransactionsTable posId={user.pos_id} />
        )}
      </Grid>
    </Grid>
  );
};

export default Transactions;
